import type { ErrorSchema } from '@rjsf/utils';

import type { TableEditorConfiguration } from '@/components/ui/dataEditor/form/tableEditor.form.type';
import type { TableErrors, TableRow } from '@/components/ui/table/table.type';

export const normalizeTableErrors = (
  data: TableRow[],
  errorSchema: ErrorSchema<TableRow[]> | undefined,
  config: TableEditorConfiguration
): TableErrors => {
  if (!(errorSchema && data && config)) {
    return {};
  }

  const normalizedErrors: TableErrors = {};
  const selector = config?.table?.dataSelectorPath || 'rowId';

  Object.entries(errorSchema).forEach(([rowIndex, rowErrors]) => {
    const index = Number(rowIndex);
    if (isNaN(index) || !data[index]) return;

    const rowId = data[index][selector] as string | undefined;
    if (rowId && rowErrors) {
      normalizedErrors[rowId] = rowErrors;
    }
  });

  return normalizedErrors;
};
